import { MapPin, Phone, Mail } from "lucide-react";
import { PageTitle } from "@/components/site/PageTitle";
import { SEDI } from "@/lib/data";

const maps = (s) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${s.indirizzo ? s.indirizzo + ", " : "IVCasa "}${s.citta}`)}`;

export default function DoveSiamo() {
  return (
    <div data-testid="dove-siamo-page">
      <PageTitle title="Dove siamo" crumbs={[{ label: "Dove siamo" }]} />
      <div className="max-w-[1240px] mx-auto px-4 pt-8">
        <img src="/img/dove-siamo.jpg" alt="Il mondo IVCasa - Dove siamo" className="w-full max-w-[900px] mx-auto h-auto" />
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SEDI.map((s) => (
            <div key={s.nome} data-testid={`sede-${s.nome.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="border border-gray-300 p-5 text-[15px] leading-7 flex flex-col">
              <h2 className="font-tit font-bold text-[var(--iv)] uppercase text-lg leading-tight mb-2">{s.nome}</h2>
              {s.indirizzo && <p className="uppercase">{s.indirizzo} - {s.citta}</p>}
              {s.referente && <p><span className="font-bold">Referente:</span> {s.referente}</p>}
              {s.tel.map((t) => (
                <a key={t} href={`tel:${t.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-[var(--iv)]"><Phone className="w-3.5 h-3.5 text-[var(--iv)]" />{t}</a>
              ))}
              {s.email && <a href={`mailto:${s.email}`} className="flex items-center gap-2 hover:text-[var(--iv)]"><Mail className="w-3.5 h-3.5 text-[var(--iv)]" />{s.email}</a>}
              <a href={maps(s)} target="_blank" rel="noreferrer" className="mt-auto pt-3 inline-flex items-center gap-1 text-[var(--iv)] font-bold hover:underline">
                <MapPin className="w-4 h-4" /> Vedi su mappa
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
